<template>

  <div>
    <div v-if="isEdit" id="edit-coupon" class="coup-list show">
      <div class="flex">
        <div class="coup-cont flex-grow-0" data-vv-scope="edit">
          <div class="coup-column">
            <div class="upload-image"><img :src="dataImg"/></div>
            <div>
              <input type="file" id="tr-upload" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
              <div class="tr-button blue-button list-button" @click="$refs.uploadImgInput.click()">Upload </div>
              <div class="tr-button list-button" @click="removeImage">Remove</div>
            </div>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Coupon Name</div>
            <input type="text" class="coup-input" v-model="name" name="Name"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Name')">{{ errors.first('edit.Name') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Coupon Code</div>
            <input type="text" class="coup-input" v-model="code" name="Code"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Code')">{{ errors.first('edit.Code') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Min. Order Total</div>
            <input type="text" class="coup-input" v-model="minValue" name="Min Order Total"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Min Order Total')">{{ errors.first('edit.Min Order Total') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Discount Amount</div>
            <input type="text" class="coup-input" v-model="value" name="Discount Amount"  v-validate="'required'">
            <span class="text-danger text-sm w-full" v-show="errors.has('edit.Discount Amount')">{{ errors.first('edit.Discount Amount') }}</span>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Discount Type</div>
            <label for="percent-edit">
              <input type="radio" id="percent-edit" v-model="type" name="discount-type" value="percent">
              Percent %</label>
            <label for="flat-edit">
              <input type="radio" id="flat-edit" v-model="type" name="discount-type" value="static">
              Flat Rate $</label>
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Usage Count per Customer</div>
            <input type="text" class="coup-input" v-model="usage_per_customer">
          </div>
          <div class="coup-column">
            <div class="coup-section-heading">Coupon Start Date</div>
            <input type="date" class="coup-input" v-model="startDate">
          </div>
          <div class="coup-column flex-grow-1">
            <div class="coup-section-heading">Coupon End Date</div>
            <input type="date" class="coup-input" v-model="endDate">
          </div>

          <div class="coup-column coup-edit">
            <h3 @click="submitSave"><i class="fas fa-save"></i> Save</h3>
            <h3 class="deactivate" @click="deactivate"><i class="far fa-lightbulb"></i> {{is_active ? 'Deactivate' : 'Activate'}} </h3>
            <h3 class="delete" @click="deleteData"><i class="fas fa-trash"></i> Delete</h3>
            <h3 class="mt-3" @click="isEdit = false"><i class="fas fa-ban" ></i> Cancel</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="coup-cont" v-else-if="coupon">
      <div class="coup-column">
        <div class="coup-section-heading">Coupon Name</div>
        <h3>{{ name }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Coupon Code</div>
        <h3>{{ code }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Min. Order Total</div>
        <h3>${{ minValue }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Discount Amount</div>
        <h3>${{ value }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Discount Type</div>
        <h3>{{ type }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Usage Count per Customer</div>
        <h3>{{ usage_per_customer }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Coupon Start Date</div>
        <h3>{{ startDate }}</h3>
      </div>
      <div class="coup-column">
        <div class="coup-section-heading">Coupon End Date</div>
        <h3>{{ endDate }}</h3>
      </div>
      <div class="coup-column coup-edit">
        <h3  @click="isEdit = true"><i class="fas fa-edit"></i> Edit</h3>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    couponData: {
      type: Object,
      required: true
    },
    updated: Function
  },
  name: 'BoundaryItem',
  data () {
    return {
      isEdit: false,
      name: '',
      code: '',
      minValue: 0,
      id: 0,
      value: 0,
      usage_per_customer: 0,
      type: 'percent', //percent | static
      is_active: false,
      startDate: moment().format('yyyy-MM-DD'),
      startHour: '00:00',
      endDate: moment().format('yyyy-MM-DD'),
      endHour: '00:00',
      coupon: null,
      dataImg: null,
      uploadImg: null
    }
  },
  methods: {

    removeImage () {
      this.dataImg = null
      this.$vs.loading()
      const obj = {
        productId: this.productId,
        restaurantId: this.restaurantId
      }
      this.$store.dispatch('api/removeProductImage', obj).then((response) => {
        this.$vs.notify({
          title: 'Image removed',
          text: response.data.message,
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })
        this.$vs.loading.close()
      }).catch(err => {
        console.error(err)
        this.$vs.notify({
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        this.$vs.loading.close()
      })

    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]
      }
    },
    openAlert (text) {
      this.$vs.dialog({
        type:'alert',
        color: 'success',
        title: 'Confirm',
        clickNotClose: true,
        acceptText: 'Ok',
        text
      })
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        clickNotClose: true,
        text: 'Are you sure you want to delete this item?',
        accept,
        cancel
      })
    },
    deleteData () {
      this.openConfirm(() => {

        const obj = {
          restaurantId: this.couponData.restaurant_id,
          couponId: this.id
        }
        this.$store.dispatch('api/removeCoupon', obj).then(() => {
          this.$vs.notify({
            title: 'Delete',
            text: 'Item deleted succesfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.updated(true)
        }).catch(err => { console.error(err) })
      }, {})
    },
    deactivate () {
      this.is_active = !this.is_active
      this.submitSave()
    },
    formatDate (value) {
      if (value) {
        return moment(String(value), 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD')
      }
    },
    submitSave () {
      this.$vs.loading()
      this.$validator.validateAll('edit').then(result => {
        if (result) {
          const obj = {
            couponId: this.coupon.id,
            name: this.name,
            code: this.code,
            minValue: this.minValue,
            startDate: `${this.startDate} ${this.startHour}`,
            endDate: `${this.endDate} ${this.endHour}`,
            type: this.type,
            value: this.value,
            usage_per_customer: this.usage_per_customer,
            restaurantId: this.couponData.restaurant_id,
            is_active: this.is_active
          }
          this.$store.dispatch('api/setCoupon', obj)
            .then(() => {
              this.updated(true)
              this.isEdit = false
              this.$vs.loading.close()
              this.openAlert('Item updated successfully')
            })
            .catch(err => {
              console.error(err)
              this.$vs.loading.close()
            })

        }
      })
    },
    setData () {
      const { id, restaurantId, name, code, usage_per_customer, min_value, start_date, end_date, type, value, is_active, photoUrl } = this.coupon

      this.id = id
      this.restaurantId = restaurantId
      this.name = name
      this.code = code
      this.minValue = min_value
      this.startDate = this.formatDate(start_date)
      this.endDate = this.formatDate(end_date)
      this.type = type
      this.value = value
      this.is_active = is_active
      this.usage_per_customer = usage_per_customer

      this.dataImg = (photoUrl !== null) ? photoUrl : require('@/assets/images/pages/register/upload_image.png')
    },
    getBoundaryInfo () {
      this.coupon = this.couponData
      this.setData()
    },
    clearData () {
      this.isEdit = false
    },
    editData () {
      this.isEdit = true
    }
  },

  mounted () {
    this.getBoundaryInfo()
  }
}
</script>

<style lang="scss">

</style>
